import { RouteObject } from "react-router-dom";
import { ProjectsDevelopmentsPage } from "src/routes/projects/ProjectsDevelopmentsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { developmentsRoute } from "src/routing/domains/developments/list/developmentsListPaths";

/**
 * `/developments` list page.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `BeamNavbarLayout` → `ProjectsDevelopmentsPage`.
 */
export const developmentsListRoute: RouteObject = {
  path: developmentsRoute.path,
  Component: AppShell,
  children: [{ Component: BeamNavbarLayout, children: [{ index: true, Component: ProjectsDevelopmentsPage }] }],
};
